<template>
    <div class="form-check-radio">
      <label :for="cbId" class="form-check-label">
        <input :id="cbId"
               type="radio"
               :disabled="disabled"
               :name="name"
               :value="label"
               :checked="currentValue === label"
               :aria-invalid="error ? 'true' : undefined"
               :aria-describedby="error ? errorId : undefined"
               @change="onChange" />
        <span class="form-check-sign">
          <slot></slot>
        </span>
      </label>
      <span v-if="error" :id="errorId" class="form-error" role="alert">{{ error }}</span>
    </div>
  </template>
  <script>
    export default {
      name: 'base-radio',
      props: {
        label: [String, Number],
        disabled: [Boolean, String],
        modelValue: [String, Number, Boolean],
        // backwards compat: Vue2 `value` prop
        value: [String, Number, Boolean],
        name: {
          type: String,
          default: ""
        },
        error: {
          type: String,
          default: ""
        },
        id: {
          type: String,
          default: ""
        },
        inline: Boolean
      },
      emits: ['update:modelValue', 'input'],
      data () {
        return {
          cbId: ''
        }
      },
      computed: {
        currentValue() {
          // prefer modelValue, fallback to legacy `value`
          return this.modelValue !== undefined ? this.modelValue : this.value
        },
        errorId() {
          return `${this.cbId}-error`
        },
        inlineClass () {
          if (this.inline) {
            return `radio-inline`
          }
          return '';
        }
      },
      methods: {
        onChange() {
          this.$emit('update:modelValue', this.label)
          this.$emit('input', this.label)
        }
      },
      created () {
        this.cbId = this.id || Math.random().toString(36).slice(2, 8)
      }
    }
  </script>

<style scoped>
.form-check-radio {
  display: flex;
  align-items: center;
  margin: 0 0 10px;
}
.form-check-radio .form-check-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  cursor: pointer;
}
.form-check-radio input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  width: 19px;
  height: 19px;
  border: 1.5px solid var(--adm-border-strong);
  border-radius: 50%;
  background: var(--adm-card);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.form-check-radio input[type="radio"]:checked {
  border-color: var(--adm-accent);
}
.form-check-radio input[type="radio"]:checked::after {
  content: '';
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--adm-accent);
}
.form-check-radio input[type="radio"]:focus {
  box-shadow: 0 0 0 3px var(--adm-accent-soft);
  outline: none;
}
.form-check-sign {
  color: var(--adm-text);
  font-size: 0.88rem;
}
.form-error {
  margin-left: 8px;
  font-size: 0.78rem;
  color: var(--adm-danger);
}
</style>
